import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';
import { DEFAULT_SPINNER_THEME, SpinnerTheme } from './spinner-theme';

@Component({
  tag: 'wb-spinner',
  styleUrl: 'spinner.scss',
  shadow: true,
})
export class SpinnerComponent implements ComponentInterface {
  /** Defines spinner appearance to match background color */
  @Prop({ reflect: true })
  public theme: SpinnerTheme = DEFAULT_SPINNER_THEME;

  /** If present, stops the spinning animation */
  @Prop({ reflect: true })
  public paused: boolean = false;

  public render(): JSX.Element {
    return (
      <Host aria-live="polite" aria-busy="true" class="wb-spinner">
        <div class="inner" />
      </Host>
    );
  }
}
